import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Layout Components
import Header from './components/Header';
import Footer from './components/Footer';

// Page Components
import Home from './pages/Home';
import Mission from './pages/Mission';
import Impact from './pages/Impact';
import GetInvolved from './pages/GetInvolved';
import NotFound from './pages/NotFound';
import Login from './pages/Login';
import Memo from './pages/Memo';
import ProtectedRoute from './components/ProtectedRoute';

// Auth Context Provider
import { AuthProvider } from './contexts/AuthContext';

import './site.css';

// Unlinked pages that haven't been written yet
const Stub = ({ title, children }) => (
  <main>
    <section className="ai-pagehead">
      <div className="ai-wrap">
        <h1>{title}</h1>
        <p>{children}</p>
      </div>
    </section>
  </main>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Login and Memo routes have no header or footer */}
            <Route path="/login" element={<Login />} />
            <Route path="/memo" element={
              <ProtectedRoute>
                <Memo />
              </ProtectedRoute>
            } />
            <Route path="/memo/update" element={
              <ProtectedRoute>
                <Memo />
              </ProtectedRoute>
            } />

            {/* Public site */}
            <Route path="/*" element={
              <div className="ai">
                <Header />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/mission" element={<Mission />} />
                  <Route path="/impact" element={<Impact />} />
                  <Route path="/careers" element={<GetInvolved />} />
                  <Route path="/for-patients" element={<Stub title="For patients">What we can do for you if you think a diagnosis was missed.</Stub>} />
                  <Route path="/for-providers" element={<Stub title="For providers">How our reviews can help your team catch diagnostic errors earlier.</Stub>} />
                  <Route path="/research" element={<Stub title="Research">What the research says about diagnostic error, and what we're learning from our own cases.</Stub>} />
                  <Route path="/blog" element={<Stub title="Blog">News and notes from the Afterimage team.</Stub>} />
                  <Route path="/support" element={<Stub title="Support">Answers to common questions.</Stub>} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
                <Footer />
              </div>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
